import { createContext, ReactNode, useContext, useState } from 'react';

interface TransientSelectedActionsContextData {
  selectedActions: string[];
  setSelectedActions: (actions: string[]) => void;
}

const TransientSelectedActionsContext =
  createContext<TransientSelectedActionsContextData>(
    {} as TransientSelectedActionsContextData,
  );

interface TransientSelectedActionsProviderProps {
  children: ReactNode;
  initialSelectedActions?: string[];
}

export function TransientSelectedActionsProvider({
  children,
  initialSelectedActions = [],
}: TransientSelectedActionsProviderProps) {
  const [selectedActions, setSelectedActions] = useState<string[]>(
    initialSelectedActions,
  );

  return (
    <TransientSelectedActionsContext.Provider
      value={{
        selectedActions,
        setSelectedActions,
      }}
    >
      {children}
    </TransientSelectedActionsContext.Provider>
  );
}

export function useTransientSelectedActions() {
  const context = useContext(TransientSelectedActionsContext);

  if (!context) {
    throw new Error(
      'useTransientSelectedActions must be used within an TransientSelectedActionsProvider',
    );
  }

  return context;
}
